import { render, staticRenderFns } from "./VisitScoreRegistration.vue?vue&type=template&id=45bf06f6&scoped=true&"
import script from "./VisitScoreRegistration.vue?vue&type=script&lang=js&"
export * from "./VisitScoreRegistration.vue?vue&type=script&lang=js&"
import style0 from "./VisitScoreRegistration.vue?vue&type=style&index=0&id=45bf06f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf06f6",
  null
  
)

export default component.exports